import {
    Checkbox,
    DialogTitle, List, ListItemButton, ListItemIcon, ListItemText,
    MenuItem,
    Tab,
    Tabs,
    TextField
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import React, {useRef, useState} from "react";
import {first, useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {useNavigate, useParams} from "react-router-dom";
import {TabWrapper} from "../../shopdrawing/TabWrapper";
import ClearIcon from '@mui/icons-material/Clear';
import {Select3} from "./Select3";
import {useBackgroundAction} from "../../manage/sov/UseBackgroundTask";
import {Alternative, alternativeLabel} from "../../../../api/QuoteAlternatives";

export function CreateAlternative(props: {
    onCancel(): void;
    onDone(): void;
}) {
    const project = useProjectId();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const onDoneRef = useSyncedRef(props.onDone)
    const nav = useNavigate();
    const projectRef = useSyncedRef(project);
    const params = useParams<{workspace: string}>();
    const paramsRef = useSyncedRef(params);

    const submit = useBackgroundAction({
        callback: (input: Parameters<typeof api.quoteAlternatives.create>[0]) => api.quoteAlternatives.create(input),
        onDone: (result) => {
            nav(`/project/${projectRef.current}/quote/${result.id}/${paramsRef.current.workspace}`);
            onDoneRef.current();
        }
    });

    const list = useAsync2((input) =>
        api.quoteAlternatives.list(input),
        {project: project}, [project]);

    const [tab, setTab] = useState("blank");
    const [from, setFrom] = useState<number[]>([]);
    const checkedRef = useRef<{[from: number]: {
        [key: string]: boolean
    }}>({})

    const doSubmit = () => {
        if(tab === "mirror" && from.length === 0) {
            alert("Please select at least one alternative to mirror")
            return;
        }

        if(!name) {
            return;
        }

        const fromList = from.map(fromId => {
            let keys: string[] = [];
            const subs = checkedRef.current[fromId];
            for(let i in subs) {
                if(subs[i] === true) {
                    keys.push(i);
                }
            }

            return {
                id: fromId,
                sections: keys,
            }
        });

        submit.callback({
            project: project,
            name: name,
            from: fromList,
            description: description,
        });
    };

    return (
        <Dialog2 open={true} onClose={props.onCancel} onEnterPress={doSubmit}>
            <DialogTitle>
                Create Quote Alternative
            </DialogTitle>
            <div style={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
                <TabWrapper>
                    <Tabs value={tab} onChange={(e, value) => {
                        setTab(value)
                        setFrom([]);
                        checkedRef.current = {};
                    }}>
                        <Tab label="Blank Slate" value="blank" />
                        <Tab label="Mirror Existing" value="mirror" />
                        <Tab label="Merge Multiple" value="merge" />
                    </Tabs>
                </TabWrapper>

                <div style={{padding: 24, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
                    <TextField fullWidth label="Name" value={name} onChange={e => setName(e.target.value)} />
                    <div style={{height: 8}} />
                    <TextField fullWidth label="Description"
                               value={description}
                               onChange={e => setDescription(e.target.value)}
                               multiline
                               rows="3"
                    />
                    <div style={{height: 16}} />

                    {tab === "blank" && <div>
                    </div>}
                    {tab === "mirror" && <Select3 fullWidth
                        label="Copy from"
                         value={from.length === 0 ? "-" : from[0].toString()}
                         onChange={e => {
                             const fromId = parseInt(e.target.value as any, 10)
                             setFrom([fromId])
                             checkedRef.current[fromId] = {};
                             sections.map(s => {checkedRef.current[fromId][s.key] = true});
                         }}>
                            <MenuItem value="-">Select item</MenuItem>
                        {list.result?.data.map(d =>
                            <MenuItem value={d.id.toString()} key={d.id.toString()}>{alternativeLabel(d)}</MenuItem>)}
                    </Select3>}
                    {tab === "merge" && <>
                        <div style={{overflow: "auto", flex: 1}}>
                            {from.map(id => (
                                <>
                                    <MenuItem key={id.toString()}>
                                        <ListItemText>{fromLabel(list.result?.data || [], id)}</ListItemText>
                                        <ListItemIcon onClick={() => setFrom(old => old.filter(i => i !== id))}>
                                            <ClearIcon />
                                        </ListItemIcon>
                                    </MenuItem>
                                    <List dense>
                                        {sections.map(s => <>
                                            <ListItemButton key={s.key}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        size="small"
                                                        onChange={(e, checked) => {
                                                            if(!checkedRef.current[id]) {
                                                                checkedRef.current[id] = {};
                                                            }

                                                            checkedRef.current[id][s.key] = checked;
                                                        }}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    style={{margin: 0, paddingRight: 16}}
                                                    primary={s.name}
                                                />
                                            </ListItemButton>
                                        </>)}
                                    </List>
                                </>
                            ))}
                        </div>
                        <div style={{height: 16}} />
                        <Select3 fullWidth label="Choose Alternative To Add"
                                value="-"
                                onChange={e => {
                                     const val = parseInt(e.target.value as any, 10);
                                     setFrom([...from, val]);
                                 }}>
                            <MenuItem value="-">Select item to add</MenuItem>
                            {list.result?.data.filter(d => from.indexOf(d.id) === -1)
                                .map(d => <MenuItem value={d.id.toString()} key={d.id.toString()}>{alternativeLabel(d)}</MenuItem>)}
                        </Select3>
                    </>}
                </div>
            </div>
            <SmoothActionBar
                loading={submit.loading}
                error={submit.error}
                actionName="Create"
                onCancel={props.onCancel}
                onSubmit={doSubmit}
            />
        </Dialog2>
    )
}

const sections = [
    {name: "Div 10", key: "div10"},
    {name: "Openings", key: "openings"},
    {name: "Hardware", key: "hardware"},
    {name: "Misc", key: "misc"},
];
function fromLabel(list: Alternative[], id: number) {
    const alt = first(list, l => l.id === id);
    return alt ? alternativeLabel(alt) : "";
}
